import { Component } from '@angular/core';
import { RevealDirective } from '../../core/directives/reveal.directive';

interface Step {
  num: string;
  title: string;
  body: string;
}

@Component({
  selector: 'hx-referral-steps',
  standalone: true,
  imports: [RevealDirective],
  template: `
    <hr class="divider" />
    <section id="referral-program">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Referral program</p>
          <h2>How referrals work.</h2>
          <p>Three steps, one reward for you and one for the business you refer.</p>
        </div>

        <div class="process-list reveal" appReveal>
          @for (step of steps; track step.num) {
            <div class="process-item">
              <span class="process-num">{{ step.num }}</span>
              <h4>{{ step.title }}</h4>
              <p>{{ step.body }}</p>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class ReferralStepsComponent {
  steps: Step[] = [
    { num: '01', title: 'Refer', body: 'Send us the contact — a quick intro email or the form below is enough to get started.' },
    { num: '02', title: 'We deliver', body: 'We scope, quote, and run the project the same way we run every Hexacorp build.' },
    { num: '03', title: 'You get paid', body: "Depending on the project, you're paid in stages as the client pays us, or in one payment after launch. Details below." },
  ];
}
